import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, defineAsyncComponent, ref, Ref, shallowRef, watch } from 'vue'

interface Props {
  colorClass?: string
  iconName: string,
  remSize?: number,
}
type Emits = (e: 'click', event: Event) => void


export default /*@__PURE__*/_defineComponent({
  __name: 'SVGIcon',
  props: {
    colorClass: { default: 'tw-fill-core-primary-50' },
    iconName: {},
    remSize: { default: 1.5 }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const rootElement = ref<HTMLElement | null>(null)

const emit = __emit

const dataTest = computed(() => `svg-icon-${props.iconName}`)
const style = computed(() => {
  const size = `${props.remSize}rem`
  return {
    height: size,
    width: size,
    'min-height': size,
    'max-height': size,
    'min-width': size,
    'max-width': size,
  }
})

watch(
  () => rootElement.value,
  () => {
    if (rootElement.value !== null) {
      rootElement.value.$el.onclick = (e: Event) => emit('click', e)
    }
  }
)

// Type is unknown because of the different typing of defineAsyncComponent between vue 2 and vue3
const icon: Ref<unknown | null> = shallowRef(null)

watch(
  () => props.iconName,
  () => {
    icon.value = defineAsyncComponent(() => import(`frontcore/assets/icons/Icon${props.iconName}.vue`))
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(icon.value), {
    ref_key: "rootElement",
    ref: rootElement,
    class: _normalizeClass(_ctx.colorClass),
    "data-test": dataTest.value,
    style: _normalizeStyle(style.value)
  }, null, 8, ["class", "data-test", "style"]))
}
}

})